import { IonIcon } from '@ionic/react';
import { alertCircle, alertCircleOutline, chatbubble, chatbubbleOutline, checkmarkCircle, checkmarkCircleOutline, ellipse, ellipseOutline } from 'ionicons/icons';
import * as React from 'react';
import { DateLocalizer, EventProps, DayLayoutFunction } from 'react-big-calendar';
import { getClient } from '../firebase/clients';
import { getCurrentUser } from '../firebase/firebase';
import { getUser } from '../firebase/users';
import { getEventStatus } from './CustomEventView';


const CustomEventView: React.FC<EventProps> = (props: any) => {
    const c = getClient(props.event.clientId);
    const u = getUser(props.event.userId);
    const currentUser = getCurrentUser();
    const eventStatusStyle = props.event.status === 2 || props.event.status === 3 || props.event.status === 4 ? { textDecoration: "line-through" } : {};
    

    if ((currentUser !== undefined && currentUser.role == "manager")) {
        return (
            <div style={eventStatusStyle} >
                    {getEventStatus(props.event)}
                    {c !== undefined ? c.surname + " " + c.name + " " : ""}
                    {c === undefined ? props.event.comments : props.event.comments !== "" ? "(" + props.event.comments + ")" : ""}                
                    {c === undefined ? props.event.managerComments : <div>{props.event.managerComments}</div>}
            </div>
        );
    } else if (currentUser !== undefined && currentUser.role === "reception") {
        return (
            <div style={eventStatusStyle} >
                {getEventStatus(props.event)}
                {c !== undefined ? c.surname + " " + c.name + " " : ""}
                {c === undefined ? props.event.comments : props.event.comments !== "" ? "(" + props.event.comments + ")" : ""}     
            </div>);
    }else if (currentUser !== undefined && props.event.userId === currentUser.id) {
        return (
            <div style={eventStatusStyle} >
                    {getEventStatus(props.event)}
                    {c !== undefined ? c.surname + " " + c.name + " " : ""}
                    {c === undefined ? props.event.comments : props.event.comments !== "" ? "(" + props.event.comments + ")" : ""}                
            </div>
        );
    } else {
        return (
            <div style={eventStatusStyle} >
                
            </div>
        );
    }

};

export default CustomEventView;